/**
 * Ovid's facets (`@core/wall/facets`): its own scenario (the fantasy a pack plays) and garment (what it is built
 * around), then setting and colour. Pack-level only: what a visitor chooses by, never shown.
 */
import {COLOUR, SETTING, type HouseFacets} from '@core/wall/facets'

export const OVID_FACETS: HouseFacets = [
    {
        key: 'scenario',
        label: 'Scenario',
        required: true,
        values: [
            {id: 'boudoir', label: 'Boudoir & lingerie', short: 'boudoir', meta: 'Bedrooms, lingerie, intimate interiors'},
            {id: 'beach', label: 'Beach & water', short: 'beach', meta: 'Beaches, pools, hot tubs, yachts, showers'},
            {id: 'outdoors', label: 'Nature & outdoors', short: 'outdoors', meta: 'Fields, forests, hikes, gardens'},
            {id: 'everyday', label: 'Home & everyday', short: 'everyday', meta: 'Kitchens, sofas, errands, the girl next door'},
            {id: 'luxury', label: 'Hotels & luxury', short: 'luxury', meta: 'Suites, villas, private jets, high life'},
            {id: 'nightlife', label: 'Nightlife & party', short: 'nightlife', meta: 'Clubs, bars, karaoke, casinos, after-parties'},
            {id: 'roles', label: 'Uniforms & roles', short: 'uniforms', meta: 'Professions, uniforms, role play'},
            {id: 'cosplay', label: 'Cosplay & gaming', short: 'cosplay', meta: 'Anime, games, comics, cosplay'},
            {id: 'fantasy', label: 'Fantasy & myth', short: 'fantasy', meta: 'Goddesses, vampires, succubi, elves, science fiction'},
            {id: 'history', label: 'History & period', short: 'period', meta: 'Period dress and historical scenes'},
            {id: 'heritage', label: 'Cultural dress', short: 'cultural dress', meta: 'Traditional dress of a culture'},
            {id: 'fetish', label: 'Fetish & latex', short: 'fetish', meta: 'Latex, leather, harness, bondage, boots'},
            {id: 'art', label: 'Art & editorial', short: 'art', meta: 'Fine-art nudes, fashion editorial, gallery light'},
            {id: 'sport', label: 'Sport & fitness', short: 'sport', meta: 'Gym, yoga, sport, athletes'},
        ],
    },
    {
        key: 'garment',
        label: 'Garment',
        required: false,
        values: [
            {id: 'lingerie', label: 'Lingerie', short: 'lingerie', meta: 'Bras, stockings, bodysuits, garters'},
            {id: 'swimwear', label: 'Swimwear', short: 'swimwear', meta: 'Bikinis, swimsuits'},
            {id: 'sheer', label: 'Sheer & wet', short: 'sheer', meta: 'See-through, wet fabric, mesh, sheer gowns'},
            {id: 'costume', label: 'Costume & uniform', short: 'costume', meta: 'Uniforms, cosplay, character costumes'},
            {id: 'traditional', label: 'Traditional dress', short: 'traditional', meta: 'Kimono, qipao, saree, dirndl and the like'},
            {id: 'evening', label: 'Evening wear', short: 'evening wear', meta: 'Gowns, cocktail dresses, jewellery'},
            {id: 'casual', label: 'Everyday clothes', short: 'casual', meta: 'Shirts, jeans, dresses, knitwear'},
            {id: 'fetishwear', label: 'Latex & leather', short: 'latex', meta: 'Latex, leather, harnesses, restraints'},
            {id: 'sportswear', label: 'Sportswear', short: 'sportswear', meta: 'Leggings, sports bras, kit'},
            {id: 'bare', label: 'Nothing much', short: 'bare', meta: 'Nude, or accessories only'},
        ],
    },
    SETTING,
    COLOUR,
]
